// Navigation
document.addEventListener("DOMContentLoaded", function () {
    const menuToggle = document.getElementById("menu-toggle");
    const navContainer = document.querySelector(".nav-container");
    const body = document.body;

    if (menuToggle) {
        menuToggle.addEventListener("click", function () {
            menuToggle.classList.toggle("is-active");
            navContainer.classList.toggle("menu-active");
            body.classList.toggle("menu-open");
        });
    }
});

// Mobile nav accordion
document.querySelectorAll(".nav-item a").forEach((link) => {
    link.addEventListener("click", (e) => {
        if (window.innerWidth > 1200) return;

        const navItem = link.closest(".nav-item");
        const dropdown = navItem.querySelector(".nav-dropdown");

        if (!dropdown) return;

        const isOpen = navItem.classList.contains("is-open");

        if (isOpen) return;

        e.preventDefault();

        document.querySelectorAll(".nav-item.is-open").forEach((item) => {
            if (item !== navItem) {
                item.classList.remove("is-open");
            }
        });

        navItem.classList.add("is-open");
    });
});

// Accordion
document.querySelectorAll(".accordion-item__header").forEach((header) => {
    header.addEventListener("click", () => {
        header.parentElement.classList.toggle("is-open");
    });
});

// OpenStreetMap single marker
document.querySelectorAll(".block-map__osm").forEach((el) => {
    const lat = parseFloat(el.dataset.lat);
    const lng = parseFloat(el.dataset.lng);
    const zoom = parseInt(el.dataset.zoom) || 15;
    const label = el.dataset.label || "";

    const map = L.map(el).setView([lat, lng], zoom);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
            '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    if (label) {
        L.marker([lat, lng]).addTo(map).bindPopup(label).openPopup();
    }
});

// Event page single marker map
const eventMapEl = document.getElementById("event-map");
if (eventMapEl) {
    const lat = parseFloat(eventMapEl.dataset.lat);
    const lng = parseFloat(eventMapEl.dataset.lng);
    const label = eventMapEl.dataset.label || "";

    const map = L.map(eventMapEl).setView([lat, lng], 13);

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
            '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    L.marker([lat, lng]).addTo(map).bindPopup(label).openPopup();
}

// Calendar
document.addEventListener("DOMContentLoaded", function () {
    const calendarEl = document.getElementById("fullcalendar");
    if (!calendarEl) return;

    const eventsUrl = calendarEl.dataset.eventsUrl;
    const isMobile = () => window.innerWidth < 768;

    const popup = document.createElement("div");
    popup.className = "calendar-popup";
    popup.innerHTML = `
      <button class="calendar-popup__close" aria-label="Close">&times;</button>
      <div class="calendar-popup__content"></div>
  `;
    document.body.appendChild(popup);

    popup
        .querySelector(".calendar-popup__close")
        .addEventListener("click", () => {
            popup.classList.remove("is-open");
        });

    document.addEventListener("click", (e) => {
        if (!popup.contains(e.target) && !e.target.closest(".fc-daygrid-day")) {
            popup.classList.remove("is-open");
        }
    });

    const calendar = new FullCalendar.Calendar(calendarEl, {
        initialView: "dayGridMonth",
        headerToolbar: {
            left: "prev",
            center: "title",
            right: "next",
        },
        events: eventsUrl,
        eventColor: "#E8720C",
        eventTextColor: "#ffffff",
        height: "auto",
        dayHeaderContent: function (arg) {
            return arg.date
                .toLocaleDateString("en-NZ", { weekday: "short" })
                .slice(0, 2);
        },

        // Add has-events to every day covered by every event (including multi-day)
        eventsSet: function (events) {
            document
                .querySelectorAll(".fc-daygrid-day.has-events")
                .forEach((el) => el.classList.remove("has-events"));

            events.forEach(function (event) {
                const start = new Date(event.start);
                const end = event.end
                    ? new Date(event.end.getTime() - 1)
                    : new Date(event.start);

                const current = new Date(start);
                while (current < end) {
                    const dateStr =
                        current.getFullYear() +
                        "-" +
                        String(current.getMonth() + 1).padStart(2, "0") +
                        "-" +
                        String(current.getDate()).padStart(2, "0");
                    const dayEl = document.querySelector(
                        `.fc-daygrid-day[data-date="${dateStr}"]`,
                    );
                    if (dayEl) dayEl.classList.add("has-events");
                    current.setDate(current.getDate() + 1);
                }

                // Single-day events: end === start, loop above won't run
                if (event.start && !event.end) {
                    const dateStr =
                        start.getFullYear() +
                        "-" +
                        String(start.getMonth() + 1).padStart(2, "0") +
                        "-" +
                        String(start.getDate()).padStart(2, "0");
                    const dayEl = document.querySelector(
                        `.fc-daygrid-day[data-date="${dateStr}"]`,
                    );
                    if (dayEl) dayEl.classList.add("has-events");
                }
            });

            events.forEach(function (event) {
                console.log("Event:", event.title);
                console.log("start:", event.start);
                console.log("end:", event.end);
                if (event.end) {
                    console.log("end -1ms:", new Date(event.end.getTime() - 1));
                }
            });
        },

        eventContent: function (arg) {
            if (isMobile()) {
                return { html: "" };
            }
            return true; // use FullCalendar's default rendering
        },

        eventClick: function (info) {
            if (isMobile()) {
                info.jsEvent.preventDefault();
                return;
            }
            info.jsEvent.preventDefault();
            if (info.event.url) {
                window.location.href = info.event.url;
            }
        },
    });

    calendarEl.addEventListener("click", (e) => {
        if (!isMobile()) return;

        const dayEl = e.target.closest(".fc-daygrid-day");
        if (!dayEl) return;

        const dateStr = dayEl.dataset.date;
        if (!dateStr) return;

        // Match events where clicked date falls within the event's range
        const dayEvents = calendar.getEvents().filter((ev) => {
            if (!ev.start) return false;

            const startStr =
                ev.start.getFullYear() +
                "-" +
                String(ev.start.getMonth() + 1).padStart(2, "0") +
                "-" +
                String(ev.start.getDate()).padStart(2, "0");

            // No end = single day event, only match start date
            if (!ev.end) return dateStr === startStr;

            // ev.end is exclusive — subtract 1 day to get actual last day
            const endDate = new Date(ev.end);
            endDate.setDate(endDate.getDate() - 1);
            const endStr =
                endDate.getFullYear() +
                "-" +
                String(endDate.getMonth() + 1).padStart(2, "0") +
                "-" +
                String(endDate.getDate()).padStart(2, "0");

            return dateStr >= startStr && dateStr <= endStr;
        });

        if (!dayEvents.length) return;

        const content = popup.querySelector(".calendar-popup__content");
        content.innerHTML = dayEvents
            .map(
                (ev) => `
          <a href="${ev.url}" class="calendar-popup__event">
              ${
                  ev.extendedProps.image
                      ? `<img src="${ev.extendedProps.image}" alt="${ev.title}" class="calendar-popup__image">`
                      : ""
              }
              <div class="calendar-popup__details">
                  <h3 class="calendar-popup__title">${ev.title}</h3>
                  ${
                      ev.extendedProps.location
                          ? `<p class="calendar-popup__location">
                          <i class="fa-solid fa-location-dot"></i>
                          ${ev.extendedProps.location}
                         </p>`
                          : ""
                  }
              </div>
          </a>
      `,
            )
            .join("");

        popup.classList.add("is-open");
    });

    calendar.render();
});
